import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { SparkSolidIcon } from '@fiverr-private/visuals';
import { Button } from '@fiverr-private/button';
import { Container } from '@fiverr-private/layout_components';
import { atoms } from '@fiverr-private/theme';
import { AppI18n } from '../../i18n';
import { textNoWrap } from './styles.ve.css';

interface GenerateBriefButtonProps extends Omit<React.ComponentProps<typeof Button>, 'children'> {
  isLoading: boolean;
  hideTextOnMobile?: boolean;
}

const pointerEventsDisabled = atoms({
  pointerEvents: 'none',
});

export const GenerateBriefButton = ({
  isLoading = false,
  hideTextOnMobile,
  ...buttonProps
}: GenerateBriefButtonProps) => (
  <Container display="flex" justifyContent="flexEnd">
    <Button className={classNames(textNoWrap, { [pointerEventsDisabled]: isLoading })} {...buttonProps}>
      <SparkSolidIcon />
      <Container display={hideTextOnMobile ? { default: 'none', md: 'flex' } : { default: 'flex' }}>
        <Container display="inline">
          <AppI18n k={isLoading ? 'generating' : 'generate_brief_button'} />
        </Container>
        {isLoading && <LoadingDots />}
      </Container>
    </Button>
  </Container>
);

const LoadingDots: React.FC = () => {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev % 3) + 1);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <Container width="20px" whiteSpace="preWrap">
      {'.'.repeat(dotCount).padEnd(3, ' ')}
    </Container>
  );
};
